import { BinderPropertyDescriptor, IBinding, View, ViewModel, ViewModelMessage } from "binder";
import { BindingPrototypeParser } from "src/binder/parser/prototype/bindingPrototype";
import { ElementProperty } from "./element";
export interface IElementPropertyValueVisitor{
    visitBindingPropertyValue(arg0: BindingPropertyValue, parameter: object): object;
    visitStaticPropertyValue(arg0: StaticPropertyValue, parameter: object): object;
    visitUnsetPropertyValue(arg0: UnsetPropertyValue, parameter: object): object;
}

export abstract class ElementPropertyValue extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ElementProperty) {
        super(parent);
        this.elementProperty = parent;
    }
    public elementProperty : ElementProperty;

    public abstract setValue(value: any);
    public abstract dispose();
    public abstract Accept(visitor:IElementPropertyValueVisitor,parameter:object):object;
    public abstract isValid():boolean;
}

export class UnsetPropertyValue extends ElementPropertyValue{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ElementProperty) {
        super(parent);
    }

    public setValue(value: any) {
        this.elementProperty.UpdateTargetElementValue(this.elementProperty.property.defaultValue);
        // this.elementProperty.element[this.elementProperty.property.name] = this.elementProperty.property.defaultValue;
        this.elementProperty.value = "default-unset";
    }
    public dispose() {
    }

    public Accept(visitor: IElementPropertyValueVisitor, parameter: object): object {
        return visitor.visitUnsetPropertyValue(this,parameter);
    }
    public isValid(): boolean {
        return true;
    }
    
}

export class StaticPropertyValue extends ElementPropertyValue{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ElementProperty) {
        super(parent);
    }
    private settedValue : any;
    public setValue(value: any) {
        this.elementProperty.UpdateTargetElementValue(value);
        this.elementProperty.value = value;
        this.settedValue = value;
    }
    public dispose() {
    }
    public Accept(visitor: IElementPropertyValueVisitor, parameter: object): object {
        return visitor.visitStaticPropertyValue(this,parameter);
    }

    getValue() {
        return this.settedValue;
    }
    public isValid(): boolean {
        return true;
    }
    
}

export class BindingPropertyValue extends ElementPropertyValue{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ElementProperty) {
        super(parent);
        this.isInvalid = false;
    }
    private binding: IBinding;
    private expression:any;
    public set isInvalid(v: boolean) { this._isInvalid = v; } public get isInvalid(): boolean { return this._isInvalid;} private _isInvalid: boolean;
    
    public setValue(value: any) {
        this.expression = value;
        let proto = BindingPrototypeParser.ParseBinding(value);
        let element = this.elementProperty.getTargetElement();
        let currentValidationStatus = this.isInvalid;
        try{
            this.binding = proto.create(element.DataContext,new BinderPropertyDescriptor(element,this.elementProperty.property.name));
            this.isInvalid = false;
        }catch(ex){
            console.log(ex);
            this.isInvalid = true;
        }
        if(currentValidationStatus!=this.isInvalid){
            this.handleMessage(new FormBuilderElementPropertyInvalidStatusChangedMessage(this.isInvalid,this));
        }
        this.elementProperty.value = value;
    }
    
    getValue():any {
        return this.expression;
    }
    
    public dispose() {
        this.binding?.release();
    }
    public Accept(visitor: IElementPropertyValueVisitor, parameter: object): object {
        return visitor.visitBindingPropertyValue(this,parameter);
    }

    public isValid(): boolean {
        if(this.isInvalid == true)
            return false;
        return true;
    }
    
}

export class FormBuilderElementPropertyInvalidStatusChangedMessage extends ViewModelMessage{
    public isInvalid:boolean;
    public value:ElementPropertyValue;
    constructor(isInvalid:boolean,value:ElementPropertyValue) {
        super();
        this.isInvalid = isInvalid;
        this.value = value;
    }
}
